module.exports = __webpack_public_path__ + "img/mazda-miata.b04318ae.jpg";